import { BaseMapper } from '@ps/utils';
import { ProjectManagerDto } from '../dtos/user-company.dto';
import { ProjectManager } from '../../models/project-manager.model';

export class ProjectManagerMapper extends BaseMapper<
  ProjectManagerDto,
  ProjectManager
> {
  public fromDto(dto: ProjectManagerDto): ProjectManager {
    return {
      id: dto.id,
      name: dto.name,
      email: dto.email,
      companyId: dto.company,
    };
  }
}
